var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab
document.querySelector(".steps").style.display = "none";
var prevTab = 0;
var selectors = document.querySelectorAll(
  '[name="insurance_property"], #insuranceFormContact [name="contact[how_would_you_like_to_provide_your_member_id?]"], #insuranceFormContact [name="contact[do_you_want_us_to_email_or_call_you_to_explain_your_benefits]"]'
);
selectors.forEach(function (value) {
  value.addEventListener("click", function (e) {
    var active = this.closest(
      `.insurance_section, .select-option, .explain-benefits`
    ).querySelector(".radio-label.active");
    if (active) {
      active.classList.remove("active");
    }
    this.nextElementSibling.classList.add("active");
    if (this.value == "No insurance") {
      contactBtn.disabled = false;
      contactBtn.innerHTML = "Fill contact form";
    } else if (this.value == "Yes insurance") {
      contactBtn.disabled = false;
      contactBtn.innerHTML = "Fill vision insurance form";
    }
    var member_id_opt_contact = document.querySelector(
      '#insuranceFormContact [name="contact[how_would_you_like_to_provide_your_member_id?]"]:checked'
    );
    var email_call_opt_contact = document.querySelector(
      '#insuranceFormContact [name="contact[do_you_want_us_to_email_or_call_you_to_explain_your_benefits]"]:checked'
    );
    if (
      member_id_opt_contact &&
      member_id_opt_contact.value == "Enter your Member ID"
    ) {
      document.querySelector("#insuranceFormContact .Member-ID").style.display =
        "block";
      document.querySelector(
        '#insuranceFormContact [name="contact[please_enter_your_member_id ]"]'
      ).disabled = false;
      document.querySelector(
        "#insuranceFormContact .insuranceCard"
      ).style.display = "none";
      document.querySelector(
        "#insuranceFormContact .uploaded_file"
      ).style.display = "none";
      document.querySelector(
        '#insuranceFormContact [name="contact[insurance_card_file]"]'
      ).disabled = true;
      document.querySelector(
        '#insuranceFormContact [name="contact[please_upload_a_picture_of_your_insurance_card]"]'
      ).disabled = true;
    } else if (
      member_id_opt_contact &&
      member_id_opt_contact.value == "Upload a picture of your insurance card"
    ) {
      document.querySelector("#insuranceFormContact .Member-ID").style.display =
        "none";
      document.querySelector(
        '#insuranceFormContact [name="contact[please_enter_your_member_id ]"]'
      ).disabled = true;
      document.querySelector(
        "#insuranceFormContact .insuranceCard"
      ).style.display = "block";
      if (
        document.querySelector(
          '#insuranceFormContact [name="contact[insurance_card_file]"]'
        ).files.length > 0
      ) {
        document.querySelector(
          "#insuranceFormContact .uploaded_file"
        ).style.display = "flex";
      }
      document.querySelector(
        '#insuranceFormContact [name="contact[insurance_card_file]"]'
      ).disabled = false;
      document.querySelector(
        '#insuranceFormContact [name="contact[please_upload_a_picture_of_your_insurance_card]"]'
      ).disabled = false;
    }

 
    document.querySelector(
        '#insuranceFormContact [type="submit"]'
      ).disabled = false;
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".prevBtn").forEach(function (value) {
    value.addEventListener("click", function () {
      $("#glassesDataContact").css("display", "block");
      $("#insuranceFormContact").css("display", "none");
      $("#contactForm").css("display", "none");
      
      nextPrevBtnContact.style.display = "block";
    });
  });
  document.querySelector("#contactBtn").addEventListener("click", function (e) {
    var insurance = document.querySelector(
      '[name="insurance_property"]:checked'
    );
    // document.querySelector(".product-regular-modal.contact").style.display =
    //   "none";
    if (insurance && insurance.value == "Yes insurance") {
      // $(".insurance-modal").addClass("opened");
      $("#glassesDataContact").css("display", "none");
      $("#insuranceFormContact").css("display", "block");
      console.log("hello .....");
      $("#prevBtn").css("display","block");
      nextPrevBtnContact.style.display = "none";
    } else if (insurance && insurance.value == "No insurance") {
      // $(".pdp-contact").addClass("opened");
      $("#glassesDataContact").css("display", "none");
      $("#contactForm").css("display", "block");
      console.log("hello ..... world");
      $("#prevBtn").css("display","block");
      nextPrevBtnContact.style.display = "none";
    }
  });
  document
    .querySelector(".closeImg.contact")
    .addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".product-regular-modal.contact").style.display =
        "none";
      $("#shopify-chat").attr("style", "display: block !important");


      // enable background scroll
      $("body").css("overflow", "auto");
      let body = document.body;
      let scrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      body.style.height = "";
      body.style.overflowY = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    });
  const contactToBuy = document.querySelector("#contact_to_buy"); // Modify selector as needed

  document
    .querySelector('#insuranceFormContact [type="submit"]')
    .addEventListener("click", async function (event) {
      event.preventDefault();
      var member_id_opt_contact = document.querySelector(
        '#insuranceFormContact [name="contact[how_would_you_like_to_provide_your_member_id?]"]:checked'
      );
      var form = document.querySelector("#insuranceFormContact form");
      if (
        member_id_opt_contact &&
        member_id_opt_contact.value == "Upload a picture of your insurance card"
      ) {
        this.innerHTML = "Please wait...";
        this.disabled = true;
        var url = await uploadFileToS3(
          document.querySelector("#insuranceFormContact #files_contact"),
          "insurance_cards/"
        );
        if (url !== undefined) {
          document.querySelector(
            "#insuranceFormContact #files_contact"
          ).disabled = true;
          var files_hidden_contact = form.querySelector(
            "#files_hidden_contact"
          );
          files_hidden_contact.value = url ?? "";
        }
        this.innerHTML = "Submit";
        this.disabled = false;
      }
      var email = form.querySelector('[name="contact[email]"]');
      if (email.disabled) {
        email.value = "none@example.com";
        email.disabled = false;
      }
      form.requestSubmit();
    });

  contactToBuy.addEventListener("click", function (event) {
    event.preventDefault(); // Prevents adding to cart
    document.querySelector("#insuranceFormContact > form").reset();
    document.querySelector("#contactForm > form").reset();
    document.querySelector(
      '#insuranceFormContact [type="submit"]'
    ).disabled = true;
    document.querySelector(
      ".product-regular-modal.contact [name='insurance_property']"
    ).checked = false;
    var active = document
      .querySelector(
        ".product-regular-modal.contact [name='insurance_property']"
      )
      .closest(".insurance_section")
      .querySelector(".radio-label.active");
    if (active) {
      active.classList.remove("active");
    }
    active = document
      .querySelector(
        "#insuranceFormContact [name='contact[how_would_you_like_to_provide_your_member_id?]']"
      )
      .closest(".select-option")
      .querySelector(".radio-label.active");
    if (active) {
      active.classList.remove("active");
    }
    
    if (active) {
      active.classList.remove("active");
    }
    $("#insuranceFormContact .insuranceCard").css("display", "none");
    $("#insuranceFormContact .Member-ID").css("display", "none");
   
    $("#glassesDataContact").css("display", "block");
    $("#contactForm").css("display", "none");
    $("#insuranceFormContact").css("display", "none");
    nextPrevBtnContact.style.display = "block";
    nextPrevBtnContact.querySelector("#contactBtn").innerHTML = "Make a selection";
    nextPrevBtnContact.querySelector("#contactBtn").disabled = true;
    $("insuranceFormContact #files_hidden_contact").value = "";
    $("#insuranceFormContact .upload_file_input").css("display", "block");
    $("#insuranceFormContact .uploaded_file").css("display", "none");
    $(".product-regular-modal.contact").addClass("opened");
    $(".product-regular-modal.contact").css("display", "block");
    $("#shopify-chat").attr("style", "display: none !important");


    // disable background scroll
    $("body").css("overflow", "hidden");
    const scrollY =
      document.documentElement.style.getPropertyValue("--scroll-y");
    const body = document.body;
    body.style.position = "fixed";
    body.style.top = `-${scrollY}`;
  });

  document
    .querySelector(
      '#insuranceFormContact [name="contact[insurance_card_file]"]'
    )
    .addEventListener("change", function (e) {
      if (this.files.length > 0) {
        $("#insuranceFormContact .uploaded_file h6").text(this.files[0].name);
        $("#insuranceFormContact .uploaded_file p").text(
          formatFileSize(this.files[0].size)
        );
        $("#insuranceFormContact .uploaded_file").css("display", "flex");
        $("#insuranceFormContact .upload_file_input").css("display", "none");
      }
    });
  document
    .querySelector("#insuranceFormContact .file_close")
    .addEventListener("click", function () {
      document.querySelector(
        '#insuranceFormContact [name="contact[insurance_card_file]"]'
      ).value = "";
      document.querySelector(
        '#insuranceFormContact [name="contact[insurance_card_file]"]'
      ).disabled = false;
      document.querySelector(
        '#insuranceFormContact [name="contact[please_upload_a_picture_of_your_insurance_card]"]'
      ).value = "";
      $("#insuranceFormContact .uploaded_file").css("display", "none");
      $("#insuranceFormContact .upload_file_input").css("display", "block");
    });
});

async function uploadFileToS3(fileSelector, directoryPath) {
  // Configure the AWS SDK to use DigitalOcean Spaces
  const spacesEndpoint = new AWS.Endpoint("sfo3.digitaloceanspaces.com");
  const s3 = new AWS.S3({
    endpoint: spacesEndpoint,
    accessKeyId: "DO00LUE9ZJ2FWA8GLF7E",
    secretAccessKey: "6I533Ebk48xVyw2wSVMo4ZoZQMxdjEHl9iH5LMyjmeY",
    region: "sfo3",
    httpOptions: {
      timeout: 300000, // 5 minutes
    },
    maxRetries: 3, // Maximum number of retries per request
    retryDelayOptions: { base: 100 }, // Initial retry delay in milliseconds (the delay grows exponentially)
  });
  let files = fileSelector.files;
  if (!files.length) {
    return alert("Please choose a file to upload first.");
  }
  let file = files[0];

  // Generate the unique file name
  let fileName = directoryPath + formatFileName(file.name);

  const bucketName = "mottopticalapp";

  const uploadParams = {
    Bucket: bucketName,
    Key: fileName,
    Body: file,
    ACL: "public-read", // Or any ACL you prefer
  };
  fileUrl = `https://mottopticalapp.sfo3.digitaloceanspaces.com/` + fileName;
  // let upload = await s3.upload(uploadParams, function(err, data) {
  //   if (err) {
  //     console.log("Error", err);
  //   }
  //   if (data) {
  //     console.log("Upload Success", data.Location);
  //   }
  // });

  // Wrap the upload in a promise
  // let uploadPromise = new Promise((resolve, reject) => {
  //   const upload = new AWS.S3.ManagedUpload({
  //     service: s3, // Use the configured S3 instance
  //     params: uploadParams,
  //     partSize: 6 * 1024 * 1024, // Optional: Set the part size for multipart upload, e.g., 6MB
  //     queueSize: 1, // Optional: Set the concurrency for part uploads
  //   });

  //   upload.on('httpUploadProgress', function(evt) {
  //     console.log('Upload Progress', evt.loaded / evt.total);
  //   });

  //   upload.send(function(err, data) {
  //     if (err) {
  //       console.log('Error', err);
  //       reject(err);
  //     } else {
  //       console.log('Upload Success', data.Location);
  //       resolve(fileUrl); // Resolve with the file URL on success
  //     }
  //   });
  // });

  // // Wait for the promise to resolve
  // return await uploadPromise;

  try {
    const result = await s3.upload(uploadParams).promise();
    console.log("Upload Success", result.Location);
    // Return the file URL on successful upload
    return fileUrl;
  } catch (err) {
    console.log("Error", err);
    throw err; // Rethrow the error if upload failed
  }
}
